module.exports = __webpack_public_path__ + "media/auto_history/badanie_techniczne-930fe749.png";